import React from 'react'
import { colors, ETAT_TACHE_LIBELLE, ETAT_TACHE_UPPERCASE, TYPE_PLANCHE, TYPE_RECURRENCE, TYPE_SURFACE_ZONE } from '../../../../utils/constants'
import { Grid } from '@material-ui/core'
import moment from 'moment'
import { convertMinToHours, getJoursRecurrenceTache, listeJoursDeRecurrenceFormatString, listeMaterielFormatLi, listePersonneFormatLi } from '../../../../utils/utils'
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import Alert from '@material-ui/icons/NotificationImportant'
import { FormattedMessage } from 'react-intl'
import Button from '../../../../components/Button'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import { PANEL_TYPE } from './constants'
import Input from '../../../../components/form/Input'
import { Field } from 'redux-form'
import Radio from '../../../../components/form/Radio'
import { CHOIX_JOUR_WEEK, FILTER_FIELDS } from '../form/FilterForm'
import InfoTache from '../../../common/information/InfoTache'
import FormattedMessageWithBold from '../../../../components/FormattedMessageWithBold'
import { WEATHER_TILE_TYPE_API } from '../../tourPlaine/component/contextePedoclimatique/service/contextePedoclimatiqueApiMapper'
import CultureIcon from '../../../../components/icon/CultureIcon'
import InfoCulture from '../../../common/information/InfoCulture'
import PlaceIcon from '../../../../components/icon/PlaceIcon'
import CommentaireIcon from '../../../../components/icon/CommentaireIcon'
import CommentSuiviList from '../../../../components/CommentSuiviList'
import { ReactComponent as Jardinier } from '../../../../icons/jardinier.svg'
import { ReactComponent as Outils } from '../../../../icons/outils-et-ustensiles.svg'
import { LocalDateTime } from '../../../../utils/date/local-date-time'
import { DateFormat, TimeFormat } from '../../../../utils/date/model/date'
import WindMillIcon from '../../../../components/icon/WindMillIcon'
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents'
import { showPrioriteWithRetard } from './tacheUtilsTs'

/** Méthode permettant de :
 * → Générer la première partie de section des panels :
 * →→ tacheDetailPanel
 * →→ SuiviDeTacheForm
 **/
export const getDescriptionTache = (currentTache, solutionTache, panelType, isFromPageSuivi, isOngletPlanif, showEtatTache, classes) => {
	const infosRecurrence = currentTache.tacheRecurrence
	const checkedEtat = isFromPageSuivi ? currentTache.statut : currentTache.etat

	const taskDateInitiale = LocalDateTime.fromAPI(currentTache.initialDate)?.toDisplayDate(DateFormat.SHORT_DATE)
	const taskDate = LocalDateTime.fromAPI(currentTache.dateDebutPlanification)?.toDisplayDate(DateFormat.SHORT_DATE)
	const taskStartTime = LocalDateTime.fromAPIKeepLocalTime(currentTache.dateDebutPlanification)?.toDisplayDate(TimeFormat.TIME_ONLY)
	const taskEndTime = LocalDateTime.fromAPIKeepLocalTime(currentTache.dateFinPlanification)?.toDisplayDate(TimeFormat.TIME_ONLY)

	return (
		{
			icon: currentTache.enRetard ? <Alert className={classes.enRetardIcon} /> // PRM290
				: checkedEtat === ETAT_TACHE_UPPERCASE.A_PLANIFIER
					? <FiberManualRecordIcon className={classes.iconTachePlanifier} />
					: checkedEtat === ETAT_TACHE_UPPERCASE.A_REALISER
						? <FiberManualRecordIcon className={classes.iconTacheRealiser} />
						: checkedEtat === ETAT_TACHE_UPPERCASE.EN_COURS
							? <PlayCircleFilledIcon className={classes.iconTacheEnCoursOuTerminee} />
							: <CheckCircleIcon className={classes.iconTacheEnCoursOuTerminee} />,
			title:
				<Grid container item direction="row" justify="space-between" alignItems="center">
					<Grid>
						<InfoTache tache={currentTache} />
					</Grid>
					{showEtatTache && <Grid className={checkedEtat === ETAT_TACHE_UPPERCASE.A_PLANIFIER
						? classes.textPlanifier
						: checkedEtat === ETAT_TACHE_UPPERCASE.A_REALISER
							? classes.textRealiser
							: classes.textEnCoursOuTerminee}>

						<span className={classes.infoTache}>
							<FormattedMessage id="gestionTaches.ecranPlanification.panels.sections.infoTache"
											  values={{
												  etat: checkedEtat === ETAT_TACHE_UPPERCASE.A_PLANIFIER
													  ? ETAT_TACHE_LIBELLE.A_PLANIFIER
													  : checkedEtat === ETAT_TACHE_UPPERCASE.A_REALISER
														  ? ETAT_TACHE_LIBELLE.A_REALISER
														  : checkedEtat === ETAT_TACHE_UPPERCASE.EN_COURS
															  ? ETAT_TACHE_LIBELLE.EN_COURS
															  : ETAT_TACHE_LIBELLE.TERMINEE
											  }}
							/>
						</span>
					</Grid>}
				</Grid>,

			content:
				<Grid>
					{currentTache.description &&
						<Grid className={classes.description}>
							{(currentTache.description.length > 0) &&
								<FormattedMessage id="gestionTaches.ecranPlanification.panels.content.descriptionTache"
												  values={{
													  description: currentTache.description
												  }}
								/>}
						</Grid>
					}

					<Grid className={classes.detailsTache}>
						{(taskStartTime && !solutionTache) && <span className={classes.textSolutionOldPlanned}><FormattedMessage
							id="gestionTaches.ecranPlanification.panels.content.realisation"
							values={{
								date: <b>{taskDate}</b>,
								startTime: <b>{taskStartTime}</b>,
								endTime: <b>{taskEndTime}</b>
							}}
						/></span>}
						{solutionTache && <>
							{solutionTache.start ? <span className={classes.textSolutionPlanned}><FormattedMessage
								id="gestionTaches.ecranPlanification.panels.content.realisation"
								values={{
									date: <b>{LocalDateTime.fromAPI(solutionTache.start).toDisplayDate(DateFormat.SHORT_DATE)}</b>,
									startTime: <b>{LocalDateTime.fromAPIKeepLocalTime(solutionTache.start).toDisplayDate(TimeFormat.TIME_ONLY)}</b>,
									endTime: <b>{LocalDateTime.fromAPIKeepLocalTime(solutionTache.end).toDisplayDate(TimeFormat.TIME_ONLY)}</b>
								}}
							/></span> : <span className={classes.textSolutionPlanned}>
								<FormattedMessage id="gestionTaches.ecranPlanification.panels.content.realisationUnplanned" />
							</span>}
							{taskStartTime && <>
								<br />
								<span className={classes.textSolutionOldPlanned}>
									<FormattedMessage
										id="gestionTaches.ecranPlanification.panels.content.realisationHorsSolution"
										values={{
											date: <b>{taskDate}</b>,
											startTime: <b>{taskStartTime}</b>,
											endTime: <b>{taskEndTime}</b>
										}}
									/>
								</span>
							</>}
						</>}
						<br />
						<FormattedMessage
							id="gestionTaches.ecranPlanification.panels.content.dateInitiale"
							values={{
								dateInitiale: <b>{taskDateInitiale}</b>
							}}
						/>
						<br /><br />

						{infosRecurrence ?
							infosRecurrence.periodeType === TYPE_RECURRENCE.SEMAINE
								? <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.recurrenceSemaine"
													values={{
														jours: <b>{listeJoursDeRecurrenceFormatString(getJoursRecurrenceTache(infosRecurrence))}</b>,
														periode: <b>{infosRecurrence.periodeNb}</b>,
														dateDebut: <b>{moment(infosRecurrence.recurrenceDebut).format('DD/MM/YYYY')}</b>,
														dateFin: <b>{moment(infosRecurrence.recurrenceFin).format('DD/MM/YYYY')}</b>
													}} />
								: <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.recurrenceMois"
													values={{
														periode: <b>{infosRecurrence.periodeNb}</b>,
														dateDebut: <b>{moment(infosRecurrence.recurrenceDebut).format('DD/MM/YYYY')}</b>,
														dateFin: <b>{moment(infosRecurrence.recurrenceFin).format('DD/MM/YYYY')}</b>
													}} />
							: <></>
						}
						{infosRecurrence && <br />}

						{currentTache.flagDivisible
							? <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.infosTacheDivisible"
												values={{ personnes: <b>{currentTache.nbPersonnes} personne(s)</b> }} />
							: <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.infosTacheIndivisible"
												values={{ personnes: <b>{currentTache.nbPersonnes} personne(s)</b> }} />
						}
						<br />

						<FormattedMessage id="gestionTaches.ecranPlanification.panels.content.estimationTempsTache"
										  values={{ duree: <b>{convertMinToHours(currentTache.duree)}</b> }}
						/>

						{isOngletPlanif && <>
							<br />
							<FormattedMessageWithBold
								id="gestionTaches.ecranPlanification.panels.content.priorite"
								values={{ priorite: showPrioriteWithRetard(currentTache.priorite, currentTache.initialDate, currentTache.date) }}
							/>
							<br />
							{currentTache.doc && currentTache.doc.trim() !== '' && <Grid className={classes.instructions}>
								<Button
									type="secondary"
									startIcon={<PictureAsPdfIcon color="currentColor" />}
									onClick={() => window.open(currentTache.doc, '_blank')}
								>
									<FormattedMessage id="gestionTaches.ecranPlanification.panels.buttons.instructions" />
								</Button>
							</Grid>}
						</>
						}

						{(panelType === PANEL_TYPE.SUIVI_DE_PRODUCTION) &&
							<Grid className={classes.formInput}>
								<br />
								{(checkedEtat !== ETAT_TACHE_UPPERCASE.A_PLANIFIER) &&
									<Grid>
										<span className={classes.text}><FormattedMessage id="gestionTaches.ecranPlanification.panels.content.etat" /></span>
										<br />

										{checkedEtat === ETAT_TACHE_UPPERCASE.A_REALISER
											? <Field name="choixEtat" component={Radio}
													 choices={[{
														 value: ETAT_TACHE_UPPERCASE.A_REALISER,
														 label: <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.checkboxRealiser" />
													 }, {
														 value: ETAT_TACHE_UPPERCASE.TERMINEE,
														 label: <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.checkboxTermine" />
													 }]}
													 column
													 style={{ justifyContent: 'space-between' }}
													 containerClass={classes.radio}
											/>
											: <Field name="choixEtat" component={Radio}
													 choices={[{
														 value: ETAT_TACHE_UPPERCASE.EN_COURS,
														 label: <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.checkboxEnCours" />
													 }, {
														 value: ETAT_TACHE_UPPERCASE.TERMINEE,
														 label: <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.checkboxTermine" />
													 }]}
													 column
													 style={{ justifyContent: 'space-between' }}
													 containerClass={classes.radio}
											/>
										}

										<br />
									</Grid>
								}

								<Field
									name="commentaire"
									component={Input}
									multiline
									label={<FormattedMessage id="gestionTaches.ecranPlanification.panels.content.commentaireLabel" />}
								/>
							</Grid>

						}
					</Grid>
				</Grid>
		})
}

/** Méthode permettant de :
 * → Formatter les values des panels de filtres (gestionTaches)
 * Utilisation dans :
 *      → AffectationTable.jsx
 *      → PlanificationTable.jsx
 **/
export const formatFilters = (filters) => {
	return Object.keys(filters).reduce((acc, curr) => {
		if (curr === FILTER_FIELDS.ONLYNONAFFECTE.name || curr === FILTER_FIELDS.RETARD.name) {
			return ({
				...acc,
				[curr]: filters[curr]
			})
		}

		if (curr === FILTER_FIELDS.CHOIXJOUR.name) {
			return ({
				...acc,
				offsetJourSemaine: filters[curr] !== CHOIX_JOUR_WEEK ? filters[curr] : undefined
			})
		}

		if (curr === FILTER_FIELDS.STATUT.name) {
			/** Ici le multi select 'status' envoi directement l'information formatée */
			return ({
				...acc,
				[curr]: Object.values(filters[curr].map(statusTache => statusTache))
			})
		}

		if ((curr === FILTER_FIELDS.CHARGEINF.name || curr === FILTER_FIELDS.CHARGESUP.name)) {
			/** Valeurs des champs chargeInf et chargeSup */
			if (filters[curr] !== null) {
				return ({
					...acc,
					[curr]: filters[curr]
				})
			}
			return ({
				...acc,
				[curr]: null
			})

		}

		/** Les autres valeurs du form sous forme d'objet */
		return ({
			...acc,
			[curr]: Object.values(filters[curr].map(n => n.code))
		})
	}, {})
}

export const displaySensibilite = (sensibilite, intl) => {
	const fields = sensibilite.split('-')
	const categorie = Object.entries(WEATHER_TILE_TYPE_API).find(([_, value]) => value.toLowerCase() === fields[0].replace('_', '').toLowerCase())[0].toLowerCase()
	const statut = fields[1].toLowerCase()
	const impact = fields[2]
	return `${intl.formatMessage({ id: `tourPlaine.contextePedoclimatique.tileType.${categorie}` })} - ${intl.formatMessage({ id: `tourPlaine.contextePedoclimatique.icons.${categorie}.${statut}.name` })} - ${intl.formatMessage({ id: `tourPlaine.contextePedoclimatique.impact.${impact}` })}`
}

/**
 * Construction des sections pour l'affichage du détail d'une tâche
 * @param currentTache tâche affichée
 * @param solutionTache informations de la tâche sur la solution
 * @param showEtatTache afficher oui/non le statut de la tâche
 * @param classes style
 * @param intl traduction
 * @return {[{icon, title, content},{icon: React.JSX.Element, title: React.JSX.Element, content: React.JSX.Element}]}
 */
export const getDetailSections = (currentTache, solutionTache, showEtatTache, classes, intl) => {
	const sections = [
		getDescriptionTache(currentTache, solutionTache, PANEL_TYPE.TACHE_DETAIL, false, true, showEtatTache, classes),
		{
			icon: <Jardinier className={classes.icon} />,
			title: <FormattedMessage id="gestionTaches.ecranPlanification.panels.sections.affectation" />,
			content:
				<Grid>
					<Grid className={classes.padText}>
						<FormattedMessage
							id="gestionTaches.ecranPlanification.panels.content.estimationTempsPersonne"
							values={{ duree: <b>{convertMinToHours(currentTache.tempsPersonne)}</b> }}
						/>
					</Grid>
					<Grid>
						<ul>
							{(!solutionTache?.unplanned) && (
								solutionTache && solutionTache?.resources ? solutionTache?.resources.map(r => <li>{r.alias}</li>) :
									listePersonneFormatLi(currentTache.affectationLightBeanList, currentTache.etat === ETAT_TACHE_UPPERCASE.EN_COURS || currentTache.etat === ETAT_TACHE_UPPERCASE.TERMINEE)
							)}
						</ul>
					</Grid>
				</Grid>
		}
	]

	if (currentTache.competences && currentTache.competences.length > 0) {
		sections.push(
			{
				icon: <EmojiEventsIcon color="primary" className={classes.icon} />,
				title: <FormattedMessage id="gestionTaches.ecranPlanification.panels.sections.competences" />,
				content:
					<Grid>
						<Grid>
							<ul>
								{currentTache.competences.map(competence => <li>{competence}</li>)}
							</ul>
						</Grid>
					</Grid>
			}
		)
	}

	if (currentTache.culture) {
		sections.push({
			icon: <CultureIcon />,
			title: currentTache.culture.nom,
			path: <Grid className={classes.padText}><InfoCulture culture={currentTache.culture} /></Grid>,
			content: <em>{currentTache.culture.cultivar}</em>
		})
	}

	if (currentTache.planche) {
		sections.push(
			{
				icon: <PlaceIcon />,
				title: <FormattedMessage id="gestionTaches.ecranPlanification.panels.sections.surface" values={{ surface: currentTache.planche.nom }} />,
				content:
					<Grid className={classes.padText}>
						{currentTache.planche.zone !== TYPE_SURFACE_ZONE.BUTTE
							? <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.surfaceDestination1"
												values={{
													zone: currentTache.planche.zone === TYPE_SURFACE_ZONE.SERRE
														? <FormattedMessage id="enums.typeSurface.SER" />
														: <FormattedMessage id="enums.typeSurface.EXT" />,
													typeBloc: currentTache.planche.bloc
												}}
							/>
							: <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.surfaceDestination1BUT"
												values={{
													zone: <FormattedMessage id="enums.typeSurface.BUT" />
												}}
							/>
						}

						<br />
						{currentTache.planche.surface
							? <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.surfaceDestination2"
												values={{
													typePlanche: currentTache.planche.typePlanche === TYPE_PLANCHE.PERMANENTE
														? <FormattedMessage id="enums.typePlanche.PER" />
														: <FormattedMessage id="enums.typePlanche.DIV" />,
													aireSurface: currentTache.planche.surface
												}}
							/>
							: <FormattedMessage id="gestionTaches.ecranPlanification.panels.content.surfaceDestination2SansSuperficie"
												values={{
													typePlanche: currentTache.planche.typePlanche === TYPE_PLANCHE.PERMANENTE
														? <FormattedMessage id="enums.typePlanche.PER" />
														: <FormattedMessage id="enums.typePlanche.DIV" />
												}}
							/>
						}

					</Grid>
			}
		)
	}

	if (currentTache.materiels.length > 0) {
		sections.push(
			{
				icon: <Outils className={classes.icon} />,
				title: <FormattedMessage id="gestionTaches.ecranPlanification.panels.sections.materiel" />,
				content:
					<Grid>
						<Grid>
							<ul>{listeMaterielFormatLi(currentTache.materiels)}</ul>
						</Grid>
					</Grid>
			}
		)
	}

	if (currentTache.sensibilites && currentTache.sensibilites.length > 0) {
		sections.push({
			icon: <WindMillIcon />,
			title: <FormattedMessage id="gestionTaches.ecranPlanification.panels.sections.sensibilite" />,
			content: <ul>
				{currentTache.sensibilites.map(sensibilite => <li>{displaySensibilite(sensibilite, intl)}</li>)}
			</ul>
		})
	}

	const comments = currentTache.commentaires
	if (comments.length > 0) {
		sections.unshift({
			icon: <CommentaireIcon color={colors.iconeDetail} />,
			title: <FormattedMessage id="planning.suivi.detail.name" />,
			content: <CommentSuiviList comments={comments} noEdit />
		})
	}

	return sections
}